import React from 'react'
import './../styles/loaderspinner.css'

const LoaderSpinner = () => {
  return (
    <div className="loaderspinner">
      <div className="loaderspinner-content">
        <div className="mul8">
          <div className="mul8circ1"></div>
          <div className="mul8circ2"></div>
        </div>
        <span className="loadspinner-text">Lade Sportevents ...</span>
      </div>
    </div>
  )
}

export default LoaderSpinner


// WEBPACK FOOTER //
// ./src/components/parts/LoaderSpinner.js